import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Badge,
  Table,
} from 'reactstrap';
import CardPanel from '../../../../shared/components/widgets/CardPanel';
import {
  getTableHeaderStyle,
  getTableRowStyle,
  getTableWrapperStyle,
  isDarkTheme,
} from '../../../../shared/helpers/themeTableStyles';

export default function ProductPerformance({
  loading, title, subtitle, data, field,
}) {
  const theme = useSelector(state => state.theme);
  const isDarkMode = isDarkTheme(theme);

  return (
    <CardPanel
      title={title}
      subhead={subtitle}
      showButtons={false}
      parentRefresh={loading}
    >
      {!loading && data && (
        <div style={getTableWrapperStyle(isDarkMode)}>
          <Table responsive className="dashboard__table-orders" id="executiveSummary">
            <thead style={{ backgroundColor: isDarkMode ? '#232531' : '#f8f9fa' }}>
              <tr>
                <th style={getTableHeaderStyle(isDarkMode)}>PRODUCTS</th>
                <th style={getTableHeaderStyle(isDarkMode)}>{field.toUpperCase()}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                const rowStyle = getTableRowStyle(isDarkMode, index % 2 === 1);
                return (
                  <tr key={item.asin} style={rowStyle}>
                    <td style={rowStyle}>{item.displayTitle}<br /><span><Badge href={item.productLink} target="_blank" color="primary">{item.asin}</Badge></span></td>
                    <td style={rowStyle}>{item.displayValue}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      )}
      {!data && !loading && (
        <p>Not available...</p>
      )}
    </CardPanel>
  );
}

ProductPerformance.defaultProps = {
  subtitle: 'By ACoS for Date Range',
  data: [],
  field: 'acos',
};

ProductPerformance.propTypes = {
  loading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  data: PropTypes.instanceOf(Array),
  field: PropTypes.string,
};
